import axios from "axios";
import { useRef, useState } from "react";
import Swal from "sweetalert2";
import useDeviceType from "../useDeviceType";

export default function BottomBar() {
  const [phone1, setPhone1] = useState<string>("010");
  const [phone2, setPhone2] = useState<string>("");
  const [phone3, setPhone3] = useState<string>("");
  const [agree, setAgree] = useState<boolean>(true);

  const phone2Ref = useRef<HTMLInputElement>(null);
  const phone3Ref = useRef<HTMLInputElement>(null);

  const onlyNumber = (value: string) => value.replace(/[^0-9]/g, "");

  const isMobile = useDeviceType();

  const handlerPostContact = async () => {
    const phone = `${phone1}${phone2}${phone3}`;

    if (!phone2 || !phone3) {
      Swal.fire({
        title: "연락처를 모두 입력해주세요.",
        icon: "error",
      });
      return false;
    }

    if (phone.length !== 11 || !phone.startsWith("010")) {
      Swal.fire({
        title: "010을 포함한 연락처를 정확히 입력해주세요.",
        icon: "error",
      });
      return false;
    }

    if (!agree) {
      Swal.fire({
        title: "개인정보 수집에 동의해주세요.",
        icon: "error",
      });
      return false;
    }

    await axios
      .post("/api/contact/quick", {
        phone: phone,
        path: sessionStorage.getItem("path"),
      })
      .then((res) => {
        if (res.data.result === "0000") {
          Swal.fire({
            title: "문의 완료!",
            text: "문의 등록이 완료되었습니다.",
            icon: "success",
          }).then(() => (window.location.href = "/transform"));
        }
      })
      .catch((e) => {
        Swal.fire({
          title: e,
          icon: "error",
        }).then(() => (window.location.href = "/"));
      });
  };

  return (
    <div className="fixed inset-x-0 bottom-0 z-10 shadow-[0_-4px_20px_rgba(0,0,0,0.25)]">
      <div className="flex flex-col items-stretch md:flex-row md:items-stretch">
        {/* Left + Center: consultation info and form (navy) */}
        <div className="flex flex-1 flex-col items-stretch gap-2 bg-[#1f2a52] py-3 md:flex-row md:items-center md:gap-6 lg:gap-10 px-[calc((100%-var(--container))/3)] md:pr-6">
          {/* Phone banner (desktop) */}
          <a href="tel:010-5762-2738" className="hidden shrink-0 lg:block">
            <img
              src={"/images/quickNum.png"}
              alt="전문성 높은 서비스로 안내해드립니다 010.5762.2738"
              className="h-9 w-auto lg:h-11 xl:h-12"
            />
          </a>

          {/* Form */}
          <div className="w-full">
            <label className="flex cursor-pointer items-center gap-1.5 text-[11px] text-white md:text-xs mb-1.5">
              <input
                type="checkbox"
                checked={agree}
                defaultChecked
                // onChange={(e) => setAgree(e.target.checked)}
                className="h-3.5 w-3.5 shrink-0 accent-[#043fff]"
              />
              상담을 위한 개인정보 수집에 동의합니다
            </label>
            <form
              className="flex w-full items-center gap-2 md:gap-3"
              onSubmit={(e) => {
                e.preventDefault();
                handlerPostContact();
              }}
            >
              <div className="flex flex-1 items-center gap-1.5 md:gap-2">
                <input
                  type="tel"
                  inputMode="numeric"
                  value={phone1}
                  maxLength={3}
                  onChange={(e) => {
                    const v = onlyNumber(e.target.value);
                    setPhone1(v);
                    if (v.length === 3) phone2Ref.current?.focus();
                  }}
                  placeholder="010"
                  className="w-full min-w-0 flex-1 rounded-md border border-transparent bg-gray-100 py-2 text-center text-sm text-font placeholder:text-gray-400 focus:border-[#043fff] focus:outline-none focus:ring-1 focus:ring-[#043fff]"
                />
                <span className="text-white/60">-</span>
                <input
                  ref={phone2Ref}
                  type="tel"
                  inputMode="numeric"
                  value={phone2}
                  maxLength={4}
                  onChange={(e) => {
                    const v = onlyNumber(e.target.value);
                    setPhone2(v);
                    if (v.length === 4) phone3Ref.current?.focus();
                  }}
                  placeholder="0000"
                  className="w-full min-w-0 flex-1 rounded-md border border-transparent bg-gray-100 py-2 text-center text-sm text-font placeholder:text-gray-400 focus:border-[#043fff] focus:outline-none focus:ring-1 focus:ring-[#043fff]"
                />
                <span className="text-white/60">-</span>
                <input
                  ref={phone3Ref}
                  type="tel"
                  inputMode="numeric"
                  value={phone3}
                  maxLength={4}
                  onChange={(e) => setPhone3(onlyNumber(e.target.value))}
                  placeholder="0000"
                  className="w-full min-w-0 flex-1 rounded-md border border-transparent bg-gray-100 py-2 text-center text-sm text-font placeholder:text-gray-400 focus:border-[#043fff] focus:outline-none focus:ring-1 focus:ring-[#043fff]"
                />
              </div>

              <button
                type="submit"
                className="shrink-0 whitespace-nowrap rounded-md bg-white px-5 md:px-6 py-2 text-sm font-bold text-[#1f2a52] transition-colors hover:bg-gray-100"
              >
                전송
              </button>
            </form>
          </div>
        </div>

        {/* Right: emergency banner (bleeds to screen edge, desktop only) */}
        <div
          onClick={() => (window.location.href = "tel:010-5762-2738")}
          className="flex cursor-pointer items-center justify-center gap-2 bg-[#ffec00] lg:pr-[calc((100%-var(--container))/3)] lg:pl-8 md:justify-start"
        >
          <span className="relative inline-block overflow-hidden animate-bounce-soft py-3 md:py-5 lg:py-6">
            <img
              className="object-contain max-h-12 lg:max-h-16"
              src={isMobile ? "/images/quickBarMo.png" : "/images/quickBar.png"}
              alt="365일 24시간 언제든지 긴급출동 서비스"
            />
            <span
              className="pointer-events-none absolute h-full inset-y-2 left-0 w-2/3 animate-shine-full bg-gradient-to-r from-transparent via-white/70 to-transparent"
              aria-hidden="true"
            />
          </span>
        </div>
      </div>
    </div>
  );
}
